module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'fields',
        'autoComplete',
    ],

    config: {
        showArrowInline: true,
        arrowIcons: {
            closed: 'fi fi-angle-down',
            opened: 'fi fi-angle-up',
        },
        nullAbleIcon: 'fi fi-times',
    },

    methods: {
        sanitizeOptionAppearance(refOption){
            refOption = refOption || {}
            const fieldConfig = this.model.config || {}
            const appearanceType = fieldConfig.appearanceType
            const attributes = (refOption.resource || {}).attributes
            const nameParts = []
            let symbol = ''
            refOption.additionalClasses = []

            if(appearanceType === 'employee'){
                if(attributes.type){
                    symbol = `fi fi-employee-${attributes.type}`
                }
                if(symbol){
                    nameParts.push(`<i class="${symbol}"></i>`)
                }
                if(refOption.realName){
                    nameParts.push(String(refOption.realName).trim())
                }
                refOption.realName = nameParts.join('')

                if(attributes.status){
                    refOption.additionalClasses.push(`status_${attributes.status}`)
                }
            } else if(appearanceType === 'customer'){
                symbol = 'fi fi-customers'
                if(symbol){
                    nameParts.push(`<i class="${symbol}"></i>`)
                }
                if(refOption.realName){
                    nameParts.push(String(refOption.realName).trim())
                }
                refOption.realName = nameParts.join('')

                if(attributes.status){
                    refOption.additionalClasses.push(`status_${attributes.status}`)
                }
                if(!attributes.confirmed){
                    refOption.additionalClasses.push('unconfirmed')
                }
            } else if(appearanceType === 'contractor'){
                symbol = 'fi fi-contractors'
                if(symbol){
                    nameParts.push(`<i class="${symbol}"></i>`)
                }
                if(refOption.realName){
                    nameParts.push(String(refOption.realName).trim())
                }
                refOption.realName = nameParts.join('')

                if(attributes.status){
                    refOption.additionalClasses.push(`status_${attributes.status}`)
                }
                if(!attributes.confirmed){
                    refOption.additionalClasses.push('unconfirmed')
                }
            } else if(appearanceType === 'job'){
                if(fieldConfig.showOnRegistrationMandatory === undefined){
                    fieldConfig.showOnRegistrationMandatory = true
                }
                // TODO: implement
                // those are not implemented yet. all flags fall back to showOnRegistration at the moment
                // if(fieldConfig.showOnCustomerOrderMandatory === undefined){
                //     fieldConfig.showOnCustomerOrderMandatory = false
                // }
                // if(fieldConfig.showOnEmployeeJobSelectionMandatory === undefined){
                //     fieldConfig.showOnEmployeeJobSelectionMandatory = false
                // }
                // if(fieldConfig.showOnOfficeEmployeeJobSelectionMandatory === undefined){
                //     fieldConfig.showOnOfficeEmployeeJobSelectionMandatory = false
                // }

                // symbol = 'fi fi-contractors'
                if(symbol){
                    nameParts.push(`<i class="${symbol}"></i>`)
                }
                if(refOption.realName){
                    nameParts.push(String(refOption.realName).trim())
                }
                if(attributes.showOnRegistration && !fieldConfig.showOnRegistrationMandatory){
                    nameParts.push(` ${storage.__('jobs.picker.jobFlagExtensions.showOnRegistration')}`)
                }

                refOption.realName = nameParts.join('')




                // for future implementation: showOnRegistration, showOnEmployeeJobSelection, showOnOfficeEmployeeJobSelection, showOnCustomerOrder
                // showOnRegistration attribute has multiple functions which hopefully changes in the future.
                if (
                    !attributes.active ||
                    (!attributes.showOnRegistration && fieldConfig.showOnRegistrationMandatory)
                ){
                    refOption.additionalClasses.push(`showOnConditionViolation`)
                    refOption.additionalClasses.push(`hiddenIfNotSelected`)
                }

                if(attributes.status){
                    refOption.additionalClasses.push(`status_${attributes.status}`)
                }
            }
        }
    }
}